import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Footer = styled.div`
  /* background-color: #caa037; */
  margin-top: 3em;
  display: flex;
  flex-direction: row;
  border-top: 1px solid #ddd;
  justify-content: center;
`;

export const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  p {
    /* margin-top: 12px; */
    text-align: center;
    width: 100%;
    font-size: 0.8em;
    display: block;
    border-top: 0.1px solid #ddd;
    /* background-color: #caa037cf; */
    font-family: ModeratThin;
  }

  span {
    color: #000;
    /* padding-left: 1em; */
    /* background-color: green; */
  }
  p {
  font-family: ${(props) => props.lang === "en" ? "Purisa, sans-serif" : "Tanha, sans-serif"};
  }
`;

export const Menu = styled.ul`
width: 50%;
justify-content: center;
flex-wrap: wrap;
margin: 8px 0;
text-align: center;
// font-family: ${(props) => props.lang === "en" ? "Purisa, sans-serif" : "Tanha, sans-serif"};
.address-phone {
    display: flex;
    font-size: clamp(15px, 1.2vw, 2em);
    justify-content: space-evenly;

    svg {
      margin: 0 4px;
    }
    
    .phone {
      direction: ltr;
      display: inline-block;
      // background-color: red;
      font-family: ${(props) => props.lang === "en" ? "ModeratLight, sans-serif" : "Tanha, sans-serif"};
    }
  }

  img {
    height: auto;
    width: 70px;
  }

`;

export const MenuLink = styled(NavLink)`
  color: ${(props) => props.theme.colors.txt.color1};
  text-decoration: none;
  padding: 0 16px;
  &:hover {
    color: ${(props) => props.theme.colors.txt.color4};
    /* transform: scale(1.05); */
    transition: transform 0.2s;
    /* font-weight: 700; */
  }
  /* font-size: clamp(12px, 1.2vw, 2em);
  color: ${(props) => props.theme.colors.colorbg};
  text-decoration: none;
  margin: 0 15px; */

  /* transition: all .2s  */
`;
